import React from 'react';
import {Image} from 'antd-mobile';
import {normalizeGamePush, isOtherGame} from '@utils/game';
import {getGamePicUrl, GamePicType} from '@/components/utils/utils';

export function SearchResultItem(props: any) {
  const handleToGame = () => {
    normalizeGamePush(props.id, isOtherGame(props.gameUrlV2));
  };
  return (
    <div className="rounded-lg overflow-hidden" onClick={handleToGame}>
      <Image
        className="aspect-[112/156] bg-cyan-50"
        src={
          props.categoryId === 2 || props.categoryId === 3
            ? getGamePicUrl(
                GamePicType.V_RECTANGLE,
                props.source,
                props.tripartiteUniqueness,
              )
            : props.otherUrl || props.gamePic
        }></Image>
      {/*<div className="bg-white p-2">*/}
      {/*  <div className="text-t2 font-bold text-xs">{props.name}</div>*/}
      {/*  <div className="text-t4 font-medium text-[0.625rem] mt-1">*/}
      {/*    {props.gameType}*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
}
